import { Button } from '@heroui/react';

export const ProductsSectionAction = ({
  text,
  largeText,
  onPress,
}: {
  text: string;
  largeText?: string;
  onPress?: () => void;
}) => {
  return (
    <>
      <Button
        size="lg"
        disableRipple
        className="-mr-4 pr-0 -my-3 text-[#9CA5AC] lg:hidden"
        variant="light"
        onPress={onPress}
      >
        {text}
      </Button>

      <Button
        size="lg"
        disableRipple
        color="primary"
        className=" hidden lg:flex"
        variant="bordered"
        onPress={onPress}
      >
        {largeText || text}
      </Button>
    </>
  );
};
